import React from "react";
import warning from '../../assets/images/icons/warning_24.svg';
import taskAlt from '../../assets/images/icons/task_alt_24.svg';
import info from '../../assets/images/icons/info_24.svg';
import report from '../../assets/images/icons/report_24.svg';
import close from '../../assets/images/icons/close_16.svg';
import '../../assets/styles/MensajeFlashStyle.css';

class MensajeFlash extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible ?? false,
            closing: false,
        };
        this.handleClose = this.handleClose.bind(this);
        this.timerId = null;
        this.closeTimeout = null;
    }

    componentDidMount() {
        this.timerId = setTimeout(this.handleClose, 5000);
    }

    componentWillUnmount() {
        clearTimeout(this.timerId);
        clearTimeout(this.closeTimeout);
    }

    componentDidUpdate(prevProps) {
        const { visible, mensaje, severity } = this.props;

        const nuevoContenido = mensaje !== prevProps.mensaje || severity !== prevProps.severity;

        if ((visible && !prevProps.visible) || (visible && nuevoContenido)) {
            clearTimeout(this.timerId);
            clearTimeout(this.closeTimeout);

            this.setState({ visible: true, closing: false }, () => {
                this.timerId = setTimeout(this.handleClose, 5000);
            });
        }

        if (!visible && prevProps.visible) {
            clearTimeout(this.timerId);
            clearTimeout(this.closeTimeout);
            this.setState({ visible: false, closing: false });
        }
    }

    handleClose() {
        if (this.state.closing) return;
        this.setState({ closing: true });
        this.closeTimeout = setTimeout(() => {
            this.setState({ visible: false, closing: false });
        }, 500);
    }

    render() {
        if (!this.state.visible) return null;

        const { mensaje, severity = 'info' } = this.props;

        let alertClass = '';
        let icon = null;
        let titulo = '';

        switch (severity) {
            case 'exito':
                alertClass = 'alert-success';
                icon = taskAlt;
                titulo = 'Operación exitosa';
                break;
            case 'info':
                alertClass = 'alert-info';
                icon = info;
                titulo = 'Información';
                break;
            case 'error':
                alertClass = 'alert-error';
                icon = report;
                titulo = 'Ha ocurrido un error';
                break;
            case 'advertencia':
                alertClass = 'alert-warning';
                icon = warning;
                titulo = 'Atención';
                break;
            default:
                alertClass = 'alert-neutral';
                icon = warning;
                titulo = 'Atención';
        }

        const divClassName = `component-alert ${alertClass} ${this.state.closing ? 'fade-out' : ''}`;

        return (
            <div className="component-toast">
                <div className={divClassName}>
                    <button className="icon-alert">
                        <img src={icon} alt={titulo.toLowerCase()} />
                    </button>
                    <div className="alert-caption">
                        <h5 className="alert-title">{titulo}</h5>
                        <p className="alert-txt">{mensaje}</p>
                    </div>
                    <button onClick={this.handleClose} className="close-alert">
                        <img src={close} alt="cerrar" />
                    </button>
                </div>
            </div>
        );
    }
}

export default MensajeFlash;